import React from 'react';
import { motion } from 'framer-motion';
export function BrandStatement() {
  return <section id="brand-statement" className="py-20 md:py-32 bg-brand-secondary" data-id="element-53">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-55">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-cream mb-6 leading-tight" data-id="element-56">
            "No somos La Cabrera.
            <br className="hidden md:block" data-id="element-57" /> Somos Cabrera."
          </h2>

          <div className="w-24 h-1 bg-brand-gold mx-auto mb-8" data-id="element-58"></div>

          <p className="text-brand-cream/70 text-base md:text-lg max-w-2xl mx-auto mb-16" data-id="element-59">
            Desde 2010 transformamos cada visita en una experiencia única de
            sabor, música y ambiente en Bogotá.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-60">
          {[{
          number: '5',
          text: 'Sedes en Bogotá'
        }, {
          number: '78K+',
          text: 'Seguidores en Instagram'
        }, {
          number: '15+',
          text: 'Años creando experiencias'
        }].map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="p-6 border border-brand-gold/20 rounded-2xl bg-brand-primary/50 hover:border-brand-gold hover:shadow-[0_0_15px_rgba(201,168,76,0.15)] transition-all duration-300" data-id="element-61">
              <div className="text-4xl md:text-5xl font-serif font-bold text-brand-gold mb-2" data-id="element-62">
                {stat.number}
              </div>
              <div className="text-brand-cream/80 font-medium" data-id="element-63">{stat.text}</div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}